import { isMobileRegular, isMobileSmall } from './checkDimensions';

export const customStyles = {
  control: (styles, { isFocused, isDisabled, selectProps }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#EBEBEB' : '#FFFFFF',
    height: '100%',
    padding: 0,
    borderRadius: 12,
    borderWidth: isFocused ? 1.5 : 1,
    borderColor: isFocused ? '#1A1A1A' : selectProps.isError ? '#CC3434' : '#BDBDBD',
    position: 'relative',
    minHeight: 62
  }),
  input: (styles) => ({
    ...styles,
    color: '#1A1A1A',
    fontSize: 14,
    fontFamily: 'Inter-Light',
    width: '100%',
    margin: 0,
    padding: 0
  }),
  menu: (styles) => ({
    ...styles,
    width: isMobileSmall ? 330 : isMobileRegular ? 380 : '100%',
    borderRadius: 12
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    color: '#000',
    fontSize: 14,
    fontFamily: 'Inter-Light',
    backgroundColor: (isFocused && 'transparent') || (isSelected && '#F5F5F5'),
    ':hover': {
      ...styles[':hover'],
      backgroundColor: '#F5F5F5'
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#1A1A1A',
    fontSize: 14,
    whiteSpace: 'normal',
    fontFamily: 'Inter-Light',
    position: 'inherit',
    width: '100%',
    margin: 'auto',
    overflow: 'visible'
  }),
  valueContainer: (styles) => ({
    ...styles,
    height: '100%',
    width: '100%',
    padding: '1px 0px 1px 3px'
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#9E9E9E',
    fontSize: 14,
    fontFamily: 'Inter-Light'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    transition: 'all .2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
  })
};
